

























import { Component, Mixins, Prop } from 'vue-property-decorator'
import FocusTrap from 'library/v4/components/FocusTrap.vue'

@Component({ components: { FocusTrap } })
export default class OzOverlay extends Mixins() {
  /**
   * Selects type of scrim. If none is selected, elements covered by the overlay will be fully visible.
   */
  @Prop({ default: 'modal' }) scrim!: 'modal' | 'popover' | null

  /**
   * Dark mode. This has no effect if scrim is turned off.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Fade the overlay and its contents in. Turn this off if you are showing a series of modals.
   */
  @Prop({ default: true }) shouldFadeIn!: boolean

  /**
   * Decides if scrim is not really there and can be clicked through
   */
  @Prop({ default: false }) isSpectral!: boolean

  get overlayClasses(): (string | Record<string, boolean> | false)[] {
    return [
      // Covers other elements on page
      'fixed',
      'inset-0',
      'z-modal2',

      // Transitions
      { fade: this.shouldFadeIn },

      // Scrim
      this.scrim === 'modal' && {
        'bg-modal-overlay-light': this.darkMode === false,
        'bg-modal-overlay-dark': this.darkMode === true,
        'bg-modal-overlay-light dark:bg-modal-overlay-dark': this.darkMode === 'auto',
      },
      this.scrim === 'popover' && {
        'bg-popover-overlay-light': this.darkMode === false,
        'bg-popover-overlay-dark': this.darkMode === true,
        'bg-popover-overlay-light dark:bg-popover-overlay-dark': this.darkMode === 'auto',
      },

      // Misc
      'touch-action-manipulation',
    ]
  }

  scrimClick(): void {
    /**
     * Emitted when user clicks or taps anywhere not occupied by the overlaid content.
     */
    this.$emit('scrim-click')
  }

  scrimEsc(): void {
    /**
     * Emitted when an escape keydown event is propagated to the overlay.
     * Since focus is trapped, it is effectively a global listener.
     */
    this.$emit('scrim-esc')
  }
}
